// packages/storefront/src/components/general/OriginNotAllowedAlert.tsx
import { Stack, Typography } from '@mui/material';
import { AlertBox } from '@tourtask/ui/components/AlertBox';
import { useLocalization } from '@tourtask/storefront/hooks/useLocalization';
import { CurrentUrlCopyBox } from '@tourtask/storefront/components/general/CurrentUrlCopyBox';

/**
 * Boot-time error rendered when the API rejects a widget's Origin
 * with `CORS.ORIGIN_NOT_ALLOWED`. Surfaces the current page URL with a
 * copy button and a translated explanation that points the partner at
 * the right backoffice page. The strings route answers any page
 * (`browserOrigins: 'any'`), so its translations are loaded even when the
 * widget's other calls are the ones that get rejected; render it through
 * `WidgetErrorAlert`, which falls back to the API's own words when they
 * are not.
 */
export function OriginNotAllowedAlert() {
  const { getStr } = useLocalization();

  return (
    <AlertBox type="error" mb={0}>
      <Stack spacing={1.5}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {getStr('This_website_is_not_registered_with_TourTask')}
        </Typography>
        <CurrentUrlCopyBox />
        <Typography variant="body2">
          {getStr('ORIGIN_NOT_ALLOWED_INFO')}
        </Typography>
      </Stack>
    </AlertBox>
  );
}
